import * as React from 'react';
import {PropsWithChildren, useState} from 'react';
import {useCache} from '../../shared-common/hooks/useCache';
import DataService from '../../shared/services/DataService';
import {isNil} from 'lodash-es';
import {AutomaticDatasetResponseFilter} from '../../shared-common/types/AutomaticDatasetResponseFilter';
import {AutomaticDatasetResponseCache} from '../../shared-common/context/AutomaticDatasetResponseCache';
import {AutomaticDataset} from '../types/AutomaticDataset';
import {useConstant} from '../../shared-ui/hooks/useConstant';

export const AutomaticDatasetResponseStore = (props: PropsWithChildren<{}>) => {
  const [isProcessing, setIsProcessing] = useState<boolean>();
  const loadedResponseKeys =
    useConstant<Map<string, AutomaticDatasetResponseFilter>>(new Map<string, AutomaticDatasetResponseFilter>());

  const {clearCache, getValue} = useCache<AutomaticDatasetResponseFilter, AutomaticDataset>(
    async (key: AutomaticDatasetResponseFilter) => {
      setIsProcessing(true);
      try {
        const response = await DataService.tryLoad<AutomaticDataset>('/engage-reports/load-automatic-dataset', {
          clientId: key.clientId,
          surveyModelId: key.surveyModelId,
          raterRelationship: key.raterRelationship,
          assesseeUserId: key.assesseeUserId
        });
        loadedResponseKeys.set(response.responseId, key);
        return response;
      } finally {
        setIsProcessing(false);
      }
    }
  );

  const getAutomaticDatasetResponse = (filter: AutomaticDatasetResponseFilter) => {
    if (isNil(filter.clientId)) {
      return undefined;
    }
    return getValue(filter);
  };

  const getResponseKey = (key?: string) => {
    if (isNil(key)) {
      return undefined;
    }

    return loadedResponseKeys.get(key);
  };

  return (
    <AutomaticDatasetResponseCache.Provider
      value={{
        getAutomaticDatasetResponse: getAutomaticDatasetResponse,
        clearAutomaticDatasetResponseCache: clearCache,
        isAutomaticDatasetResponseCacheProcessing: isProcessing,
        getResponseKey: getResponseKey
      }}
    >
      {props.children}
    </AutomaticDatasetResponseCache.Provider>
  );
};